<template>
  <table class="tables m-auto">
    <tbody>
    <tr>
      <td
          :colspan="
            datasource.children && datasource.children.length
              ? datasource.children.length * 2
              : null
          "
      >
        <div
            class="chartNode"
            style="min-width: 9rem"
            :id="datasource.id"
        >
          <slot :node-data="datasource">
<!--            {{datasource}}-->
            <div v-if="datasource.type == 0">
              <div class="text-center mb-2" @click.stop="handleClicks(datasource)" v-if="datasource.src != undefined">
                <div style="width: 50px; height: 50px" class="m-auto">
                  <img :src="datasource.src" class="c-avatar-img" alt="">
                </div>
              </div>
              <div >
                <p  style="margin-left: 0.5rem; margin-right: 0.5rem">
                  {{ datasource.name }}
                </p>
              </div>
              <div class="chartContent" v-if="datasource.title != undefined">
                <p style="margin-left: 0.5rem; margin-right: 0.5rem">
                  {{ datasource.title }}
                </p>
              </div>
              <div>
                <span class="add p-1"   @click.stop="handleClick(datasource)">
                  <CIcon name="cil-user-follow" />
                </span>
<!--                <span class="add"   @click.stop="handleClicks(datasource)">-->
<!--                  <CIcon name="cil-pencil" size="sm"/>-->
<!--                </span>-->
              </div>
            </div>

            <div v-if="datasource.type != 0">


              <div class="text-center mb-2" @click.stop="handleClicks(datasource)" >
                <div style="width: 50px; height: 50px" class="m-auto">
                  <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png" class="c-avatar-img" alt="">
                </div>
              </div>
              <div class="chartTitle">
                <div></div>
                <p style="margin-left: 0.5rem; margin-right: 0.5rem">
                  {{ onCheckLangs(datasource.by.accounts) }}
<!--                  {{ onCheckLang(datasource.by.accounts.userinfo.prefix)+' '+onCheckLang(datasource.by.accounts.userinfo.firstName)+' '+onCheckLang(datasource.by.accounts.userinfo.lastName) }}-->
                </p>
              </div>
              <div class="chartContent">
                <p style="margin-left: 0.5rem; margin-right: 0.5rem">

<!--                  {{ onCheckLang(datasource.by.position.title) }}-->

                  {{getLastPositionId(datasource.by.fields,"personnelType")}}
                </p>
              </div>
              <div>
                <span class="add p-1"   @click.stop="handleClick(datasource)">
                  <CIcon name="cil-user-follow" />
                </span>
              </div>
            </div>

          </slot>
        </div>
      </td>
    </tr>
    <template v-if="datasource.children && datasource.children.length">
      <tr class="chartLines">
        <td :colspan="datasource.children.length * 2">
          <div class="chartDownLine"></div>
        </td>
      </tr>
      <tr class="chartLines">
        <td class="chartRightLine"></td>
        <template v-for="n in datasource.children.length - 1" >
          <td class="chartLeftLine chartTopLine"></td>
          <td class="chartRightLine chartTopLine"></td>
        </template>
        <td class="chartLeftLine"></td>
      </tr>
      <tr class="nodes">
        <td colspan="2" v-for="child in datasource.children" :key="child.id">
          <node :datasource="child" :handle-click="handleClick" :handle-clicks="handleClicks">
            <template
                v-for="slot in Object.keys($slots)"
                v-slot:[slot]="scope"
            >
              <slot :name="slot" v-bind="scope" />
            </template>
          </node>
        </td>
      </tr>
    </template>
    </tbody>
  </table>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "node",
  props: {
    datasource: Object,
    handleClick: Function,
    handleClicks: Function,
  },
  methods: {
    onCheckLang(item){
      try {
        return item.filter(title => {if (title.key == this.lang) { return title } })[0].value
      }catch (e) {
        return ""
      }

    },

    onCheckLangs(item){


      try {
        return item.userinfo.prefix.filter(title => {if (title.key == this.lang) { return title } })[0].value +" "+item.userinfo.firstName.filter(title => {if (title.key == this.lang) { return title } })[0].value+" "+item.userinfo.lastName.filter(title => {if (title.key == this.lang) { return title } })[0].value
      }catch (e) {
        console.log(item)
        return "Error"
      }

    },
    getLastPositionId(data,objKey) {
      // ตรวจสอบว่า array มีข้อมูลหรือไม่
      if (!data || data.length === 0) {
        return null;
      }

      // ดึงข้อมูลจาก object สุดท้ายใน array
      const lastEntry = data[data.length - 1];

      // ตรวจสอบว่ามี positionId หรือไม่
      if (lastEntry && lastEntry[objKey]) {
        var test = ""
        try {
          test = lastEntry[objKey].title.filter(objs => {if (objs.key == this.lang) { return objs } })[0].value
        }catch (e) {

        }
        return test
      }

      return null;
    }

},
  computed: {
    ...mapGetters({
      lang: 'setting/lang',
    })
  },
};
</script>

<style>
.table {
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  border-collapse: separate;
}

.chartNode {
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  position: relative;
  margin: 0 1px 2px 1px;
  /*max-width: 20px;*/
  /*border: 1px solid #f56868;*/
  text-align: center;
  transition-property: color, background-color, border-color,
  text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter,
  backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  border-radius: 0.35rem;
}
.add{
  cursor: pointer;
}
/*.chartNode:hover {*/
/*  box-shadow: 0 0 5px #f56868;*/
/*  cursor: default;*/
/*  z-index: 20;*/
/*}*/

.chartTitle {
  text-align: center;
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1.25rem;
  overflow: hidden;
  white-space: nowrap;
  background: #f56868;
  color: white;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.chartContent {
  box-sizing: border-box;
  width: 100%;
  height: 1.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  border: #f56868;
  text-align: center;
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  background: white;
  color: black;
  overflow: hidden;
  white-space: nowrap;
}

.chartLines {
  height: 1.25rem;
}

.chartDownLine {
  background: #f56868;
  margin-left: auto;
  margin-right: auto;
  height: 1.25rem;
  width: 0.125rem;
  float: none;
}

.chartTopLine {
  border-top-color: #f56868;
  border-top-style: solid;
  border-top-width: 2px;
}

.chartRightLine {
  border-right-color: #f56868;
  border-right-style: solid;
  border-right-width: 2px;
}

.chartLeftLine {
  border-left-color: #f56868;
  border-left-style: solid;
  border-left-width: 2px;
}
</style>
